import React from 'react'
import { Badge, Button, PricingTreatment, StoreIcon } from 'baby-design'
import { LinkOut, ShoppingCartEmpty } from 'baby-design/icons'

import { RegItemOfferProps } from './RegItemOffer.types'
import css from './RegItemOffer.styles.scss'
import RegItemPricingLockup from '../RegItemPricingLockup/RegItemPricingLockup'
import { getButtonAccessibleText, getHandleClick } from './RegItemOffer.utils'

const RegItemOffer: React.FC<RegItemOfferProps> = ({ offer, regItem }) => {
  const handleClick = getHandleClick(offer)
  const buttonAccessibleText = getButtonAccessibleText(!!offer.isBabylist)

  return (
    <div className={css.RegItemOffer} data-testid="RegItemOffer">
      <div className={css.RegItemOffer__Offer}>
        <StoreIcon
          className={css.RegItemOffer__StoreIcon}
          store={{ name: offer.storeIconName }}
        />
        <div>
          <div className={css.RegItemOffer__StoreName}>
            {offer.isBabylist ? 'Babylist Shop' : offer.storeDisplayName}
          </div>
          <div className={css.RegItemOffer__Price}>
            {offer.isBabylist && (
              <>
                {regItem.isAvailableOnBabylist ? (
                  <RegItemPricingLockup
                    regItem={{
                      ...regItem,
                      offers: [offer], // Only pass babylist offer to get special sale treatments
                    }}
                    size="small"
                  />
                ) : (
                  <div className={css.RegItemOffer__OutOfStockBadge}>
                    <Badge
                      fill="gray"
                      label="Out of stock"
                      size="small"
                      variant="promo"
                    />
                  </div>
                )}
              </>
            )}
            {!offer.isBabylist && (
              <PricingTreatment price={Number(offer.price)} size="sm" />
            )}
          </div>
        </div>
        <div className={css.RegItemOffer__CTA}>
          {offer.isBabylist && regItem.isAvailableOnBabylist && (
            <Button
              icon={{
                side: 'right',
                size: 'xl',
                icon: <ShoppingCartEmpty />,
              }}
              size="sm"
              title={buttonAccessibleText}
              variant="primary"
              onClick={handleClick}
            >
              Add
            </Button>
          )}
          {!offer.isBabylist && (
            <Button
              icon={{
                side: 'right',
                size: 'md',
                icon: <LinkOut />,
              }}
              size="sm"
              title={buttonAccessibleText}
              variant="tertiary"
              onClick={handleClick}
            >
              Buy
            </Button>
          )}
        </div>

        <button
          aria-label={buttonAccessibleText}
          className={css.RegItemOffer__OverlayButton}
          data-testid="OverlayButton"
          type="button"
          onClick={handleClick}
        />
      </div>

      {offer.isBabylist && (
        <div className={css.RegItemOffer__BabylistDetails}>
          {regItem.deliveryEstimate && (
            <div className={css.RegItemOffer__DeliveryEstimate}>
              <div className={css.RegItemOffer__DeliveryEstimateLabel}>
                Estimated delivery
              </div>
              <div className={css.RegItemOffer__DeliveryEstimateValue}>
                {regItem.deliveryEstimate.message}
              </div>
            </div>
          )}
          <div className={css.RegItemOffer__FreeShipping}>
            Free shipping over $45
          </div>
        </div>
      )}
    </div>
  )
}

export default RegItemOffer
